import React from 'react';
import { TextButton } from '@Shared.Angular/flowingly.components/buttons/TextButton';

export type RecordingInProgressOverlayProps = {
  onStop: () => void;
};

export const RecordingInProgressOverlay = ({
  onStop
}: RecordingInProgressOverlayProps) => {
  return (
    <div
      className="recording-in-progress-overlay"
      data-testid="recording-in-progress-overlay"
    >
      <p className="recording-in-progress-overlay__text">
        Recording in progress
      </p>
      <TextButton
        text="Stop"
        type="secondary"
        testId="recording-in-progress-stop-button"
        onClick={onStop}
      />
    </div>
  );
};
